import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarBookV1Response } from './get-grammar-book-v1-response';
import { getGrammarBookV1ResponseSchema } from './get-grammar-book-v1-response';

export async function getGrammarBookV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarBookV1Response>> {
  return getRequest<IGetGrammarBookV1Response>({
    path: '/grammar/book/v1',
    schema: getGrammarBookV1ResponseSchema,
    options,
  });
}
